import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS_Mapper extends BaseFormMapper<CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS);

		return _formData;
	}

	MapValues(): Partial<CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS> {
		return {};
	}
}

const Mappings: CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page2[0]",
	solicitorName: 'topmostSubform[0].Page2[0].INPUT20[0]',
	date: 'topmostSubform[0].Page2[0].INPUT19[0]',
	address: 'topmostSubform[0].Page2[0].INPUT11[0]',
	telephoneNumber: 'topmostSubform[0].Page2[0].INPUT9[0]',
	lawFimeName: 'topmostSubform[0].Page2[0].INPUT8[0]',
	faxNumber: 'topmostSubform[0].Page2[0].INPUT10[0]',
	branchTransit: 'topmostSubform[0].Page2[0].INPUT6[0]',
	branchAddress: 'topmostSubform[0].Page2[0].INPUT7[0]',
	exceptions: 'topmostSubform[0].Page2[0].INPUT5[0]',
	province2: 'topmostSubform[0].Page2[0].INPUT4[0]',
	province1: 'topmostSubform[0].Page2[0].INPUT3[0]',
	option3: 'topmostSubform[0].Page2[0].RadioButtonList[2]',
	titleInsuranceCertificate: 'topmostSubform[0].Page2[0].INPUT2[0]',
	titleInsuranceCompany: 'topmostSubform[0].Page2[0].INPUT1[0]',
	option2: 'topmostSubform[0].Page2[0].RadioButtonList[1]',
	option1: 'topmostSubform[0].Page2[0].RadioButtonList[0]',
	// "18":"topmostSubform[0].Page1[0]",
	mortgageRank: 'topmostSubform[0].Page1[0].INPUT15[0]',
	fundsRequiredDate: 'topmostSubform[0].Page1[0].INPUT14[0]',
	requisitionedAmount: 'topmostSubform[0].Page1[0].INPUT13[0]',
	trustNumber: 'topmostSubform[0].Page1[0].INPUT11[0]',
	transitNumber: 'topmostSubform[0].Page1[0].INPUT10[0]',
	bankName: 'topmostSubform[0].Page1[0].INPUT9[0]',
	trustName: 'topmostSubform[0].Page1[0].INPUT12[0]',
	mortgageAmount: 'topmostSubform[0].Page1[0].INPUT7[0]',
	annualTaxAmount: 'topmostSubform[0].Page1[0].INPUT6[0]',
	municialTaxOfficeName: 'topmostSubform[0].Page1[0].INPUT4[0]',
	rollNumber: 'topmostSubform[0].Page1[0].INPUT5[0]',
	adjustmentDate: 'topmostSubform[0].Page1[0].INPUT8[0]',
	propertyType: 'topmostSubform[0].Page1[0].PROP_TYPE[0]',
	legalDescrpition: 'topmostSubform[0].Page1[0].INPUT3[0]',
	postalCode: 'topmostSubform[0].Page1[0].PROP_POSTAL_CODE[0]',
	city: 'topmostSubform[0].Page1[0].PROP_CITY[0]',
	streetName: 'topmostSubform[0].Page1[0].PROP_STREET[0]',
	streetNumber: 'topmostSubform[0].Page1[0].PROP_CIVIC[0]',
	unitNumber: 'topmostSubform[0].Page1[0].PROP_UNIT[0]',
	province: 'topmostSubform[0].Page1[0].PROP_PROVINCE[0]',
	guarantorLastName3: 'topmostSubform[0].Page1[0].GUARANTOR_03_LNAME[0]',
	guarantorMiddleName3: 'topmostSubform[0].Page1[0].GUARABTOR_03_MNAME[0]',
	guarantorFirstName3: 'topmostSubform[0].Page1[0].GUARANTOR_03_FNAME[0]',
	guarantorLastName2: 'topmostSubform[0].Page1[0].GUARANTOR_02_LNAME[0]',
	guarantorFirstName2: 'topmostSubform[0].Page1[0].GUARANTOR_02_FNAME[0]',
	guarantorLastName1: 'topmostSubform[0].Page1[0].GUARANTOR_01_LNAME[0]',
	guarantorMiddleName1: 'topmostSubform[0].Page1[0].GUARANTOR_01_MNAME[0]',
	guarantorFirstName1: 'topmostSubform[0].Page1[0].GUARANTOR_01_FNAME[0]',
	guarantorMiddleName2: 'topmostSubform[0].Page1[0].GUARANTOR_02_MNAME[0]',
	lastName9: 'topmostSubform[0].Page1[0].MORTGAGOR_09_LNAME[0]',
	middleName9: 'topmostSubform[0].Page1[0].MORTGAGOR_09_MNAME[0]',
	firstName9: 'topmostSubform[0].Page1[0].MORTGAGOR_09_FNAME[0]',
	lastName8: 'topmostSubform[0].Page1[0].MORTGAGOR_08_LNAME[0]',
	middleName8: 'topmostSubform[0].Page1[0].MORTGAGOR_08_MNAME[0]',
	firstName8: 'topmostSubform[0].Page1[0].MORTGAGOR_08_FNAME[0]',
	lastName7: 'topmostSubform[0].Page1[0].MORTGAGOR_07_LNAME[0]',
	middleName7: 'topmostSubform[0].Page1[0].MORTGAGOR_07_MNAME[0]',
	firstName7: 'topmostSubform[0].Page1[0].MORTGAGOR_07_FNAME[0]',
	lastName6: 'topmostSubform[0].Page1[0].MORTGAGOR_06_LNAME[0]',
	middleName6: 'topmostSubform[0].Page1[0].MORTGAGOR_06_MNAME[0]',
	firstName6: 'topmostSubform[0].Page1[0].MORTGAGOR_06_FNAME[0]',
	lastName5: 'topmostSubform[0].Page1[0].MORTGAGOR_05_LNAME[0]',
	middleName5: 'topmostSubform[0].Page1[0].MORTGAGOR_05_MNAME[0]',
	firstName5: 'topmostSubform[0].Page1[0].MORTGAGOR_05_FNAME[0]',
	lastName4: 'topmostSubform[0].Page1[0].MORTGAGOR_04_LNAME[0]',
	middleName4: 'topmostSubform[0].Page1[0].MORTGAGOR_04_MNAME[0]',
	firstName4: 'topmostSubform[0].Page1[0].MORTGAGOR_04_FNAME[0]',
	lastName3: 'topmostSubform[0].Page1[0].MORTGAGOR_03_LNAME[0]',
	firstName3: 'topmostSubform[0].Page1[0].MORTGAGOR_03_FNAME[0]',
	lastName2: 'topmostSubform[0].Page1[0].MORTGAGOR_02_LNAME[0]',
	middleName2: 'topmostSubform[0].Page1[0].MORTGAGOR_02_MNAME[0]',
	firstName2: 'topmostSubform[0].Page1[0].MORTGAGOR_02_FNAME[0]',
	lastName1: 'topmostSubform[0].Page1[0].MORTGAGOR_01_LNAME[0]',
	middleName1: 'topmostSubform[0].Page1[0].MORTGAGOR_01_MNAME[0]',
	middleName3: 'topmostSubform[0].Page1[0].MORTGAGOR_03_MNAME[0]',
	firstName1: 'topmostSubform[0].Page1[0].MORTGAGOR_01_FNAME[0]',
	cibcMortgageNumber: 'topmostSubform[0].Page1[0].ID_PRET_CLIENT[0]',
	// "76":"topmostSubform[0].Page1[0].BARCODE[0]"
};

export interface CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS {
	cibcMortgageNumber: string;

	firstName1: string;
	firstName2: string;
	firstName3: string;
	firstName4: string;
	firstName5: string;
	firstName6: string;
	firstName7: string;
	firstName8: string;
	firstName9: string;

	middleName1: string;
	middleName2: string;
	middleName3: string;
	middleName4: string;
	middleName5: string;
	middleName6: string;
	middleName7: string;
	middleName8: string;
	middleName9: string;

	lastName1: string;
	lastName2: string;
	lastName3: string;
	lastName4: string;
	lastName5: string;
	lastName6: string;
	lastName7: string;
	lastName8: string;
	lastName9: string;

	guarantorFirstName1: string;
	guarantorFirstName3: string;
	guarantorFirstName2: string;

	guarantorMiddleName1: string;
	guarantorMiddleName2: string;
	guarantorMiddleName3: string;

	guarantorLastName1: string;
	guarantorLastName2: string;
	guarantorLastName3: string;

	unitNumber: string;
	streetNumber: string;
	streetName: string;
	city: string;
	province: string;
	postalCode: string;
	legalDescrpition: string;

	propertyType: string;
	municialTaxOfficeName: string;
	rollNumber: string;
	annualTaxAmount: string;

	mortgageAmount: string;
	adjustmentDate: string;

	bankName: string;
	transitNumber: string;
	trustNumber: string;
	trustName: string;

	requisitionedAmount: string;
	fundsRequiredDate: string;
	mortgageRank: string;

	option1: string;
	option2: string;
	option3: string;

	titleInsuranceCompany: string;
	titleInsuranceCertificate: string;

	province1: string;
	province2: string;

	exceptions: string;

	branchTransit: string;
	branchAddress: string;

	lawFimeName: string;
	telephoneNumber: string;
	faxNumber: string;
	address: string;
	date: string;

	solicitorName: string;
}
